import React from 'react';
import { useParams, Navigate } from 'react-router-dom';

// The standalone "World" screen was merged into the District (cinematic reveal).
// Any old /world/:pillar link now redirects straight into the gamified district.
export default function World() {
  const { pillar } = useParams();
  return <Navigate to={`/district/${pillar}`} replace />;
}
